var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('logo-title',{attrs:{"hotKeyWords":_vm.hotKeyWords,"url":"http://daxue.xdf.cn/xinban/","logoPos":"background-position: 4px -240px"}}),_vm._v(" "),_c('swiper'),_vm._v(" "),_c('keep-alive',[_c('cart')],1),_vm._v(" "),_c('main-floor')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c7a171a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/univercity/Univercity.vue
// module id = null
// module chunks = 